import React, { Fragment } from 'react'
import QRcode from "qrcode.react";

function index({ data }) {
  return (
    <Fragment>
      {
        
        data && data.map((ticket, i) => {
          return (
            <div key={i} className="box  row">
              <div className="logo-box col-2">
                <div className='logo'>
                  <img
                    src={window.origin + "/img/logo/nikotanlogotecket.png"}
                    alt="logo-nikotan"
                  />
                </div>
              </div>
              <div className="col-10 p-1">
                <div className="details-user ">
                  <div className="d-flex justify-content-between">
                    <span>نام ورزشکار: {ticket.user_name}</span>
                    <span>کد ملی: {ticket.user_nationalcode}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>شماره تماس: {ticket.user_tel}</span>
                    <span>تاریخ: {ticket.dateoforder}</span>
                  </div>
                </div>
                <div className="order-details p-1">
                  <div>
                    <span> نام کلاس  : {ticket.item_name}</span>
                  </div>
                  <div>
                    <span>آدرس برگزار کننده  : {ticket.item_address}</span>
                  </div>
                  {
                    ticket.link != 'false' ? (<div className="">
                      <span className='d-block'>ادرس  یا لینک کلاس : </span><a className='d-block ' href={ticket.link}>{ticket.link}</a>
                    </div>) : <></>
                  }
                  <div className=" text-center">
                    <span>مبلغ پرداختی : {ticket.price} تومان</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <span style={{ fontSize: "8px", textAlign: "center" }}>برای دیدن جزیییات بیشتر میتوانید به داشبورد خود مراجعه کنید.</span>
                  </div>
                </div>
                <div className="qr d-flex justify-content-evenly">
                  <div className='d-flex flex-column justify-content-center align-items-center'>
                    <QRcode value={"http://nikotan.ir?trackingcode=" + ticket.trackingcodeorder} style={{ width: "100px", height: "100px" }} />
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                      <div>
                        <span>کدپیگیری سفارش:{ticket.trackingcodeorder}</span>
                      </div>
                      <div>
                        <span>کدپیگیری پرداخت:{ticket.tracingcodepayment}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          );
        })
      }
    </Fragment>
  );
}

export default index
